const NetworkDetectionsUrl = (props) => {
  const url = props?.row?.original?.log.url || "-";

  return <span title={url}>{url}</span>;
};

export default NetworkDetectionsUrl;
